"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Carousel: true,
  CarouselSlide: true
};
Object.defineProperty(exports, "Carousel", {
  enumerable: true,
  get: function () {
    return _Carousel.Carousel;
  }
});
Object.defineProperty(exports, "CarouselSlide", {
  enumerable: true,
  get: function () {
    return _CarouselSlide.CarouselSlide;
  }
});
var _Carousel = require("./Carousel");
var _CarouselSlide = require("./CarouselSlide");
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
var _constants = require("./constants");
Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constants[key];
    }
  });
});
var _carouselClasses = require("./carouselClasses");
Object.keys(_carouselClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _carouselClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _carouselClasses[key];
    }
  });
});
